import { Button, Modal, ModalHeader, ModalBody } from "reactstrap"
import FontAwesome from "react-fontawesome"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { AssetSummary } from "@swipesense/asset-components"

import AssetHistoryWithCalendar from "../AssetHistoryWithCalendar"
import LastLocation from "../LastLocation"
import "./AssetHistoryModal.scss"

const AssetHistoryModal = ({ asset }) => {
  const [modal, setModal] = useState(false)

  const toggle = () => setModal(!modal)

  const closeButton = (
    <FontAwesome className="clearInput" onClick={toggle} name={"times"} />
  )

  const historyButton = (
    <FontAwesome className="history-button" name={"history"} />
  )

  return (
    <div className="AssetHistoryModal">
      <Button className="modal-button" onClick={toggle} title="history button">
        {historyButton}
      </Button>
      <Modal
        isOpen={modal}
        toggle={toggle}
        backdrop={true}
        centered={true}
        size={"lg"}
      >
        <ModalHeader toggle={toggle} close={closeButton}>
          Asset Location History
        </ModalHeader>
        <ModalBody>
          <div className="asset-history-card">
            <div className="asset-history-header">
              <AssetSummary {...asset} />
              <LastLocation
                location={asset.location}
                notDetected={
                  asset.timeSinceDetected == null || asset.location === null
                }
                timeSinceDetected={asset.timeSinceDetected}
              />
            </div>
            <AssetHistoryWithCalendar
              id={asset.id}
              lastMovedAt={asset.lastMovedAt}
              timeSinceDetected={asset.timeSinceDetected}
            />
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

AssetHistoryModal.propTypes = {
  asset: PropTypes.shape({
    assetId: PropTypes.string,
    desktopPhotoUrl: PropTypes.string,
    deviceType: PropTypes.string,
    fallbackUrl: PropTypes.string,
    id: PropTypes.string.isRequired,
    idle: PropTypes.string,
    lastMovedAt: PropTypes.string,
    location: PropTypes.shape({
      id: PropTypes.string,
      locationType: PropTypes.string,
      name: PropTypes.string,
      patientArea: PropTypes.bool,
      unit: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }).isRequired,
    }),
    manufacturer: PropTypes.string.isRequired,
    mobilePhotoUrl: PropTypes.string,
    modelName: PropTypes.string.isRequired,
    owners: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })),
    ownership: PropTypes.string,
    serialNumber: PropTypes.string,
    timeSinceDetected: PropTypes.number,
  }),
}

export default AssetHistoryModal
